import '../fesd/fesd'
import { methods } from '../includes/_methods'
import '../../sass/news/news_detail.sass'


$(function() {
  _common.commonSwiper('.common-swiper',900);
  $('._articleBlock').article4();
  _common.blockSwiper('.other-swiper');
  methods.copyUrl('.copylink', 'Copied!');
})
